import {
  changePaymentPasswd,
  checkPaymentPasswd,
  setPaymentPasswd,
  successCode,
  validatePaymentPasswd,
} from '../api';
import useStore from '../state/useStore';

export default function usePaymentPasswd() {
  const { setPaymentPwdExists, paymentPwdExists } = useStore();
  const setPasswd = async (passwd: string) => {
    try {
      const res = await setPaymentPasswd({
        passwd,
      });
      if (res.code === successCode) {
        return true;
      }
    } catch (err) {
      console.error('setPasswd', err);
    }
    return false;
  };
  const changePasswd = async (old_passwd: string, new_passwd: string) => {
    try {
      const { code, message } = await changePaymentPasswd({
        old_passwd,
        new_passwd,
      });
      if (code === successCode) {
        return true;
      }
      return false;
    } catch (err) {
      console.error('changePasswd', err);
      return false;
    }
  };
  const validatePasswd = async (passwd: string) => {
    try {
      const { code } = await validatePaymentPasswd({ passwd });
      if (code === successCode) {
        return true;
      }
      return false;
    } catch (err) {
      console.error('validatePasswd', err);
      return false;
    }
  };
  const checkPasswd = async () => {
    try {
      const { code, data } = await checkPaymentPasswd();
      if (code === successCode) {
        return setPaymentPwdExists(data?.is_exists ? 1 : 0);
      }
      return setPaymentPwdExists(-1);
    } catch (err) {
      console.error('checkpasswd', err);
      return setPaymentPwdExists(-1);
    }
  };

  return {
    setPasswd,
    changePasswd,
    validatePasswd,
    checkPasswd,
    paymentPwdExists,
  };
}
